import { render, staticRenderFns } from "./ckeditor4.vue?vue&type=template&id=4fc3b378&"
import script from "./ckeditor4.vue?vue&type=script&lang=js&"
export * from "./ckeditor4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fc3b378')) {
      api.createRecord('4fc3b378', component.options)
    } else {
      api.reload('4fc3b378', component.options)
    }
    module.hot.accept("./ckeditor4.vue?vue&type=template&id=4fc3b378&", function () {
      api.rerender('4fc3b378', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/ckeditor4.vue"
export default component.exports